import React from "react";
import { useNavigate } from "react-router-dom";
import MuiTooltipWrapper from "../Tooltip/Tooltip";
import { Tooltip } from "@mui/material";

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();
  
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <ol className="inline-flex items-center space-x-1 sm:space-x-2 md:space-x-3 rtl:space-x-reverse min-w-max px-1">
        {items.map((item, index) => (
          <li key={index} className="inline-flex items-center flex-shrink-0">
            {index === 0 ? (
              // First item
              <button
                onClick={() =>
                  item.onClick ? item.onClick() : navigate(item.path)
                }
                className={`inline-flex items-center text-xs sm:text-sm font-medium 
                   hover:text-font-primary-main text-background-primary-main cursor-pointer transition-colors duration-200`}
              >
                {item.icon && (
                  <span className="mr-1 sm:mr-2 flex-shrink-0">
                    {item.icon}
                  </span>
                )}
                <Tooltip title={item.label} placement="bottom" arrow>
                  <span className="max-w-[110px] sm:max-w-[140px] md:max-w-[180px] lg:max-w-52 truncate">
                    {item.label}
                  </span>
                </Tooltip>
              </button>
            ) : (
              // Other items
              <div className="flex items-center">
                <svg
                  className="rtl:rotate-180 w-2.5 h-2.5 sm:w-3 sm:h-3 text-gray-400 mx-0.5 sm:mx-1 flex-shrink-0"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 9 4-4-4-4"
                  />
                </svg>
                {(item.onClick || item.path) ? (
                  <button
                    onClick={() =>
                      item.onClick ? item.onClick() : navigate(item.path)
                    }
                    className={`ml-0.5 sm:ml-1 text-xs sm:text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis 
                    max-w-[100px] sm:max-w-[150px] md:max-w-[200px] lg:max-w-[250px] ${
                      index === items.length - 1
                        ? "text-font-secondary-black hover:text-black"
                        : "hover:text-font-primary-main text-background-primary-main"
                    } cursor-pointer transition-colors duration-200`}
                  >
                    {item.label}
                  </button>
                ) : (
                  <div
                    className={`ml-0.5 sm:ml-1 text-xs sm:text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis 
                    max-w-[100px] sm:max-w-[150px] md:max-w-[200px] lg:max-w-[250px] ${
                      index === items.length - 1
                        ? "text-font-secondary-black"
                        : "text-background-primary-main"
                    }`}
                  >
                    <MuiTooltipWrapper title={item.label} placement = {"bottom-start"} >
                      <span>{item.label}</span>
                    </MuiTooltipWrapper>
                  </div>
                )}
              </div>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Breadcrumbs;